"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../redux/actions/modalActions");
var _MarginDepositModalComponent = _interopRequireDefault(require("./MarginDepositModalComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.MARGIN_DEPOSIT
})(_MarginDepositModalComponent["default"]);